import React from 'react';
import Helmet from 'react-helmet';
import * as styles from './DraftPostItem.scss';

function DraftPostEditBar(props) {
  var getFeedbackThread = props.getFeedbackThread,
      handleEdit = props.handleEdit,
      organization = props.organization,
      deletePost = props.deletePost,
      requestDraftApproval = props.requestDraftApproval,
      post = props.post,
      setSnackbarMessage = props.setSnackbarMessage,
      showFeedbackModal = props.showFeedbackModal,
      hasFeedback = props.hasFeedback;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.editBar
  }, /*#__PURE__*/React.createElement("i", {
    className: "".concat(styles.editBarIcon, " icon ion-edit"),
    onClick: function onClick() {
      handleEdit(post);
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(styles.editBarIcon, " icon ion-paper-airplane"),
    onClick: function onClick() {
      requestDraftApproval(post);
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: hasFeedback ? "".concat(styles.editBarIcon, " fa fa-comments") : "".concat(styles.editBarIcon, " fa fa-comments-o"),
    style: hasFeedback ? {
      color: '#56B348'
    } : {},
    onClick: function onClick() {
      if (hasFeedback) {
        getFeedbackThread(organization.id, hasFeedback.id);
      }

      showFeedbackModal();
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(styles.editBarIcon, " icon ion-ios-trash-outline"),
    onClick: function onClick() {
      if (window.confirm('Are you sure you want to delete this draft?')) {
        deletePost(organization.id, post.id);
        setSnackbarMessage('Post deleted.');
      }
    },
    style: {
      fontSize: 28
    }
  }));
}

export default DraftPostEditBar;